import {Image, useTheme, VStack} from '@chakra-ui/react';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import ChatCard from '.';
import DefaultEventImage from '../../../assets/logos/logo_72x72.png';
import {TextG14} from '../../../components/typography';

const LifestyleChatCard = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <ChatCard showDivider={false} setHeight={false}>
      <VStack
        minW="fit-content"
        align="center"
        onClick={() => !closed && navigate(`/lifestyle/chat`)}>
        <Image
          borderRadius="100%"
          w="70px"
          h="70px"
          objectFit="cover"
          //fallbackSrc={DefaultEventImage}
          src={DefaultEventImage}
        />
        <VStack align="center" w="100%">
          <TextG14
            //w="80px"
            noOfLines={1}
            fontWeight="500"
            color={closed ? theme.colors.lightestGrey : theme.colors.lightBlack}>
            Group Chat
          </TextG14>

          {/* {numUsers && (
            <TextG12
              mt="0 !important"
              color={closed ? theme.colors.lightestGrey : theme.colors.grey}>
              {`${numUsers}`} {numUsers <= 1 ? 'Person' : 'People'}
            </TextG12>
          )} */}
          {/* {numUnread > 0 && (
              <>
                <DotSeparator
                  color={theme.colors.rose}
                  width="4px"
                  height="4px"
                  marginLeft="0"
                  marginRight="0"
                />
                <TextG12 color={theme.colors.rose} margin="0 !important">
                  {numUnread == 1 ? 'New Message' : 'New Messsages'}
                </TextG12>
              </>
            )} */}
        </VStack>
      </VStack>
    </ChatCard>
  );
};

export default LifestyleChatCard;
